import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createUserFailed, createUserSuccessful } from '../actions';
import { MODULE_BACK_PATH, MODULE_DTO } from '../constants';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';
import UserDTO from '../../../dto/UserDTO';

export default function* createUser(action) {
  try {
    const item = new UserDTO(action.payload);
    const url = `${BACKEND_URL}/${MODULE_BACK_PATH}`;
    const pool = item.getCreateData();
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(createUserSuccessful([]));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(createUserFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createUserFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
